import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { unionBy } from 'lodash'
import { RequestParams, ResponseCatalog } from 'Models'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'
import {
	contractApi,
	ContractModel,
	contractNS,
	contractSlice,
	contractSelector,
	CONTRACT_PARAMS,
} from 'Pages/advertisement'
import { Deserialize } from 'cerialize'

function* getContractsList(action: contractNS.getContractsList) {
	try {
		const { params, clear, callback } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(contractSlice.actions.clearAll())
		}
		const newParams = {
			...params,
			query_type: CONTRACT_PARAMS,
		} as unknown as RequestParams

		const res = yield* call(contractApi.getAll, newParams)
		const logsResponse = new ResponseCatalog<ContractModel>(res)
		logsResponse.entries = logsResponse.entries.map(
			(log): ContractModel => Deserialize(log, ContractModel)
		)
		if (!clear) {
			const oldLogs = yield* select(contractSelector.selectContractEntries)
			logsResponse.entries = [...oldLogs, ...logsResponse.entries]
		}
		yield* put(contractSlice.actions.setAll(logsResponse))
		yield* put(contractSlice.actions.setRequestParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}
function* getContractListSelect(action?: contractNS.getContractListSelect) {
	try {
		const { params, options } = action.payload
		let paramsForRequest: RequestParams
		if (params) {
			paramsForRequest = params
		} else {
			paramsForRequest = yield* select(contractSelector.selectCurrentParams)
		}
		const res = yield* call(contractApi.getAll, paramsForRequest)
		const items = new ResponseCatalog<ContractModel>(res)
		if (options?.loadMore || options?.searchMissing) {
			const oldItems = yield* select(contractSelector.selectContractList)
			items.entries = options?.searchMissing
				? oldItems.entries.concat(items.entries)
				: unionBy(oldItems.entries, items.entries, 'id')
			if (options?.searchMissing) items.total_entries = oldItems.total_entries
		}
		yield* put(contractSlice.actions.setAll(items))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getContractsOne(action: contractNS.GetContracts) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(contractApi.getOne, action.payload)
		yield* put(contractSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}
function* createContracts(action: contractNS.CreateContracts) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(contractApi.createOne, action.payload)
		yield* put(contractSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.advertisment.index))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}
function* updateContracts(action: contractNS.UpdateContracts) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, data } = action.payload
		const res = yield* call(contractApi.updateOne, id, data)
		yield* put(contractSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.advertisment.index))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* contractSaga() {
	yield* takeLatest(contractSlice.actions.getAll.type, getContractsList)
	yield* takeLatest(contractSlice.actions.getOne.type, getContractsOne)
	yield* takeLatest(contractSlice.actions.createOne.type, createContracts)
	yield* takeLatest(contractSlice.actions.getListSelect.type, getContractListSelect)
	yield* takeLatest(contractSlice.actions.updateOne.type, updateContracts)
}
